import { trackSearchFlyoutClick } from '@libs/analytics';

export function trackSearchResultsFallback(query: string, url: string) {
    trackSearchFlyoutClick({ term: query, header: '', url });
}
